import { Stack, Box, Paper, Button, CircularProgress } from "@mui/material";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import InputText from "@components/atoms/InputText/InputText";
import { IEditProductUI } from "src/types/organisms";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import LoadingGif from "../../../assets/gifs/loading.gif";
import { useFormValidate } from "@utils/hooks";
const EditProductUI = ({
  register,
  onSubmit,
  loadingData,
  isLoading,
  showError,
  errors,
  closeError,
  handleCancelClick
}: IEditProductUI) => {
  const {
    validateField
  } = useFormValidate();
  return <>
      <TitlePage title="Editar producto" subtitle="En la sección de edición de productos, puedes ajustar precios o mejorar descripciones de manera efectiva." />
      <Paper elevation={12} sx={{
      width: 1,
      padding: "24px",
      marginTop: 3
    }} onKeyDown={e => e.key.toLowerCase() === "enter" ? onSubmit() : null}>
        <TitlePaper title="Información del producto" subtitle="Detalle completo de este producto." />
        {!loadingData && <Stack component="form" direction={"row"} justifyContent={"space-between"} alignItems={"flex-start"} marginTop={3} flexWrap={"wrap"} noValidate>
            <Box marginBottom={2} width={0.49}>
              <InputText label={"Nombre"} name={"description"} placeholder={"Ingresa el nombre"} register={register("description", {
            required: true
          })} helperText={validateField(errors?.description)} disabled={isLoading} />
            </Box>
            <Box marginBottom={2} width={0.49}>
              <InputText label={"Referencia"} name={"reference"} placeholder={"Ingresa la referencia"} register={register("reference", {
            required: true
          })} helperText={validateField(errors?.reference)} disabled={isLoading} />
            </Box>
            <Box marginBottom={2} width={0.49}>
              <InputText label={"Precio"} name={"price"} placeholder={"$ 0.00"} register={register("price", {
            required: true
          })} helperText={validateField(errors?.price)} disabled={isLoading} />
            </Box>
          </Stack>}
        <Stack direction={"row"} justifyContent={"center"}>
          <Box component={"img"} display={loadingData ? "block" : "none"} src={LoadingGif} width={170} />
        </Stack>
      </Paper>
      <Stack direction={"row"} justifyContent={"flex-end"} marginTop={3} spacing={3}>
        <Button color="secondary" size="large" disabled={isLoading || loadingData} onClick={handleCancelClick}>
          Cancelar
        </Button>
        <Button type="submit" size="large" onClick={isLoading ? () => null : onSubmit} disabled={loadingData} endIcon={isLoading && <CircularProgress thickness={3} size={20} sx={{
        color: "white"
      }} />}>
          {isLoading ? "Guardando" : "Guardar cambios"}
        </Button>
      </Stack>
      <ErrorAlert open={showError} onClose={closeError} message={"Lo sentimos, no se pudo actualizar este producto, intentalo nuevamente"} />
    </>;
};
export default EditProductUI;